/* Customily injects #customily-preview-button into .product-form__buttons
   (alongside the theme's add-to-cart). Move it INSIDE #cl_optionsapp so
   the gray personalization card visually contains the preview action,
   matching the Customall product layout (where .btn-preview sits inside
   .ctm-customize-product). */
(function () {
  var LOG = '[customily-preview-mover]';

  function movePreviewIntoCard() {
    var card = document.querySelector('#cl_optionsapp');
    var btn = document.querySelector('#customily-preview-button');
    if (!card || !btn) return false;
    if (card.contains(btn)) return true;
    try {
      card.appendChild(btn);
      console.log(LOG, 'moved #customily-preview-button into #cl_optionsapp');
      return true;
    } catch (e) {
      console.error(LOG, 'move failed:', e);
      return false;
    }
  }

  function init() {
    console.log(LOG, 'init');
    movePreviewIntoCard();

    /* Customily mounts asynchronously and may re-render the button on
       variant change. Watch the DOM for ~60s and keep moving as needed. */
    var observer = new MutationObserver(movePreviewIntoCard);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* When the cart drawer opens after add-to-cart, Customily's app-level
   "Sticky Preview" (toggled on in Customily admin) can render above the
   drawer due to stacking-context quirks (its parent .product__media-item
   may create a new stacking context, escaping a pure z-index fix). Tag
   <body> with `cart-open` while EITHER Dawn's <cart-drawer> has the
   `.active` class OR the external SlideCartHQ drawer is visible —
   companion CSS in customily-style-v2.css hides .cl-canvas-container and
   the product media while the class is present. */
(function () {
  /* "Open" means actually ON-SCREEN — not merely present in the DOM.
     SlideCartHQ keeps its <div class="slidecarthq"> mounted at all times,
     parked just off the right edge (left ≈ window.innerWidth) when closed,
     with display:flex / visibility:visible. A naive display/visibility +
     width/height check therefore reads a CLOSED drawer as visible and pins
     body.cart-open permanently — which hides the product gallery. Require
     the panel's box to overlap the viewport instead. */
  function isOnScreen(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) return false;
    return r.left < window.innerWidth - 10 && r.right > 10 &&
           r.top < window.innerHeight - 10 && r.bottom > 10;
  }

  function update() {
    var slidecartOpen = isOnScreen(document.querySelector('.slidecarthq'));
    var dawnCartOpen = !!document.querySelector('cart-drawer.active');
    document.body.classList.toggle('cart-open', slidecartOpen || dawnCartOpen);
  }

  function watch() {
    update();
    var observer = new MutationObserver(update);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden', 'hidden'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();

/* Customily renders its OWN add-to-cart button (#customily-cart-btn) with
   the app-config text "добави в количка" (lowercase д), separate from the
   theme button. Customall's button is "Добави в количка" (capital Д, set by
   the i18n in customall-*.js). Capitalise Customily's to match. Observe for
   variant-change re-renders. (Cleanest source-of-truth fix is the button-
   text field in Customily admin; this is the client-side equivalent.) */
(function () {
  function fix() {
    var btn = document.querySelector('#customily-cart-btn');
    if (!btn) return;
    var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.replace(/\s+/g, ' ').trim() === 'добави в количка') {
        node.nodeValue = node.nodeValue.replace('добави в количка', 'Добави в количка');
      }
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; fix(); }, 150);
  }

  function init() {
    schedule();
    var observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
